import React from "react";
import { compose } from "redux";

import connectActions from "fantastic/lib/connectActions";
import connectProps from "fantastic/lib/connectProps";
import setHovered from "fantastic/actions/setHovered";
import setSelected from "fantastic/actions/setSelected";
import getSelected from "fantastic/selectors/getSelected";
import sectionsOperations from "fantastic/lib/sections";

const Breadcrumbs = ({ selected, sections, setHovered, setSelected }) => {
  const selectedNode = sectionsOperations.byId(selected, sections);
  const ignoreTypes = ["COLUMN"];

  const {
    meta: { parentNodes }
  } = selectedNode;

  const icons = {
    block: "fi fi-block-b",
    button: "fi fi-button-b",
    divider: "fi fi-divider-b",
    image: "fi fi-image-b",
    section: "fi fi-section",
    social: "fi fi-social",
    spacer: "fi fi-spacer-b",
    table: "fi fi-table-b",
    cell: "fi fi-cell",
    unsubscrible: "fi fi-block-b",
    organization: "fi fi-block-b",
    map: "fi fi-map-b",
    video: "fi fi-video-b",
    html: "fi fi-html-b fi--bold"
  };

  const iconByType = (type, kind) => {
    if (type === "ITEM") return icons[kind];

    return icons[type.toLowerCase()];
  };

  const renderBread = ({ id, name, type, kind }, index) => {
    return (
      !ignoreTypes.includes(type) && (
        <li
          key={index}
          onClick={() => setSelected(id)}
          onMouseOver={() => setHovered(id)}
          onMouseOut={() => setHovered(null)}
        >
          <a title={name}>
            <i className={iconByType(type, kind)}></i>
          </a>
        </li>
      )
    );
  };

  const renderSelf = () => {
    const {
      meta: { type, kind, name }
    } = selectedNode;
    return (
      <li>
        <a title={name}>
          <i className={iconByType(type, kind)}></i>
        </a>
      </li>
    );
  };

  if (!parentNodes) return null;

  return (
    <ul className="fantastic-breadcrumbs">
      {parentNodes.map(renderBread)}
      {renderSelf()}
    </ul>
  );
};

export default compose(
  connectProps({ selected: getSelected }, "sections"),
  connectActions({ setHovered, setSelected })
)(Breadcrumbs);
